import React from 'react';
import { Box, Grid, Link, Typography } from '@mui/material';
import logoWhite from '../../assets/images/logo-white.png';
import { FacebookOutlined, Instagram, LinkedIn, Language } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  contact: {
    padding: '45px 0 0 !important',
    '@media (max-width: 900px)': {
      padding: '0 0 25px 50px !important',
    },
  },
}));

const Footer = () => {
  const { contact } = useStyles();
  return (
    <footer
      style={{
        marginTop: '40px',
        position: 'relative',
        bottom: '0px',
      }}
    >
      <Box bgcolor="primary.main" color="white">
        <Box sx={{ padding: '30px 50px !important' }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  paddingBottom: '15px',
                  '@media (max-width:600px)': {
                    width: '150px',
                  },
                }}
              >
                <img src={logoWhite} alt="Logo da empresa HWater" style={{ height: '40px', width: 'auto' }} />
              </Box>
              <Box>
                <Link
                  sx={{
                    color: 'white',
                    paddingRight: '15px',
                    '&:visited': {
                      color: 'white',
                    },
                    '&:hover, &:active': {
                      color: '#E4F2FF',
                    },
                  }}
                  target="_blank"
                  href="https://www.facebook.com/grupohwater"
                  aria-label="facebook"
                >
                  <FacebookOutlined sx={{ height: '28px', width: '28px' }} />
                </Link>
                <Link
                  sx={{
                    color: 'white',
                    paddingRight: '15px',
                    '&:visited': {
                      color: 'white',
                    },
                    '&:hover, &:active': {
                      color: '#E4F2FF',
                    },
                  }}
                  target="_blank"
                  href="https://www.instagram.com/hwater.solutions/"
                  aria-label="instagram"
                >
                  <Instagram sx={{ height: '28px', width: '28px' }} />
                </Link>
                <Link
                  sx={{
                    color: 'white',
                    paddingRight: '15px',
                    '&:visited': {
                      color: 'white',
                    },
                    '&:hover, &:active': {
                      color: '#E4F2FF',
                    },
                  }}
                  target="_blank"
                  href="https://www.linkedin.com/company/grupohwater/"
                  aria-label="linkedin"
                >
                  <LinkedIn sx={{ height: '28px', width: '28px' }} />
                </Link>
                <Link
                  sx={{
                    color: 'white',
                    paddingRight: '15px',
                    '&:visited': { color: 'white' },
                    '&:hover, &:active': { color: '#E4F2FF' },
                  }}
                  target="_blank"
                  href="https://hwater.com.br"
                  aria-label="website"
                >
                  <Language sx={{ height: '28px', width: '28px' }} />
                </Link>
                {/* <Link
                sx={{ color: 'white', paddingRight: '15px', '&:visited': {
                      color: 'white',
                    },
                    '&:hover, &:active': {
                    color: '#E4F2FF'
                  } }}
                target="_blank"
                href="#"
                aria-label="youtube"
              >
                <YouTube sx={{ height: '28px', width: '28px' }} />
              </Link> */}
              </Box>
            </Grid>
            <Grid item xs={12} md={4} className={contact} sx={{ textAlign: { xs: 'left', md: 'right' }, ml: { md: 'auto' }, pr: { md: '0' } }}>
              <Typography variant="h6">Contato</Typography>
              <Typography paragraph sx={{ fontSize: '0.813rem' }}>
                Em caso de dúvidas, reclamações ou feedbacks, entre em contato conosco.<br />
                Teremos o maior prazer em atender sua solicitação.
              </Typography>
              <Typography sx={{ fontSize: '0.813rem', fontWeight: 500 }}>
                Basta enviar um e-mail para:{' '}
                <Link
                  href="mailto:contato@hwater.com.br"
                  sx={{ color: 'white', '&:visited': { color: 'white' }, '&:hover, &:active': { color: '#E4F2FF' } }}
                >
                  contato@hwater.com.br
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
